import { getFilesCheckedList } from '../../../../File'
import {
  getPhotoTileIdByFile,
  toPhotoUploadFailures,
} from '../../RentalPortalPhotoGallery.utils'

export async function getPhotoCheckedFilesList({ files, ...params }) {
  return Promise.all(
    files.map(file =>
      getFilesCheckedList({ ...params, files: [file] })
        .then(([result]) => result)
        .catch(() => toPhotoUploadFailures([file])[0])
    )
  )
}

export function getPhotoUploadTile({
  cancelledTileIds,
  file,
  tileIdByFile,
  tileIdByResult,
}) {
  const tileId =
    tileIdByResult.get(file) ?? getPhotoTileIdByFile({ file, tileIdByFile })

  return {
    isCancelled: Boolean(tileId) && cancelledTileIds.delete(tileId),
    tileId,
  }
}
